<template>
    <div class="app-container">

        <div class="filter-container">
            <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">
                新建标题包
            </el-button>
        </div>

        <el-table
            v-loading="listLoading"
            :data="list"
            element-loading-text="Loading"
            border
            fit
            highlight-current-row
        >
            <el-table-column align="center" label="标题包ID" width="95">
                <template slot-scope="scope">
                    {{ scope.row.packageId }}
                </template>
            </el-table-column>
            <el-table-column label="标题包名称">
                <template slot-scope="scope">
                    {{ scope.row.packageName }}
                </template>
            </el-table-column>
            <el-table-column label="标题数量">
                <template slot-scope="scope">
                    {{ scope.row.titleNum }}
                </template>
            </el-table-column>
            <el-table-column label="关联计划数">
                <template slot-scope="scope">
                    {{ scope.row.planNum }}
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
                <template slot-scope="{row,$index}">
                    <el-button type="primary" size="mini" @click="handleUpdate(row)">
                        编辑
                    </el-button>

                    <el-button v-if="row.status!='deleted'" size="mini" type="danger" @click="handleDelete(row,$index)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination v-show="total>0" :total="total" :page.sync="listQuery.current" :limit.sync="listQuery.pageSize" @pagination="fetchData"/>


        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="70%">
            <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="70px" style="width: 400px; margin-left:50px;">
                <el-form-item label="标题" prop="packageName">
                    <el-input v-model="temp.packageName"/>
                </el-form-item>
            </el-form>
            <Title ref="titleChild" :cur-ad-plat-id="curAdPlatId" :is-select="true" @getSelectList="getSelectList"></Title>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">
                    取消
                </el-button>
                <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import Vue from 'vue';
import {Table, TableColumn, FormItem, Input, Button, Dialog, Loading, Form, MessageBox, Notification, Tabs, TabPane} from 'element-ui';
import Pagination from '@/components/Pagination/index.vue'
import {ToolAdPlatMap} from '../../../../utils/map'
import {adPlatJDOptions, adReportEventJDOptions} from "../../goodsInfo/jd/config";
import Title from "./title";

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Button)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Loading)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification


export default {
    components: {Title, Pagination},
    props: {
        curAdPlatId: {
            type: String,
            default: '400',
            require: true
        },
    },
    watch: {
        curAdPlatId(curVal, oldVal) {
            if (curVal) {
                console.log("new ad plat id : " + curVal);
                this.fetchData();
            }
        }
    },
    data() {
        return {
            selectTitleList: [],
            listQuery: {
                current: 1,
                pageSize: 10,
            },
            textMap: {
                update: '编辑',
                create: '新建标题包'
            },
            rules: {
                packageName: [{required: true, message: '请输入标题', trigger: 'blur'}, {min: 1, max: 30, message: '最多30个字符', trigger: 'blur'}]
            },
            dialogFormVisible: false,
            list: [],
            dialogStatus: '',
            listLoading: true,
            total: 0,
            temp: {
                packageName: '',
                adPlatId: this.curAdPlatId,
                customerId: '40',
                titleIdList: []
            },
        }
    }
    ,
    created() {
        this.fetchData();
    }
    ,
    methods: {
        fetchData() {
            this.listLoading = true
            this.httpGetList().then(response => {
                this.list = response.data;
                this.total = response.total;
                this.listLoading = false
            })
        }
        ,
        handleTabClick(tab, event) {
            // 切换tab 重新请求列表
            this.titleTab = 'title';
            this.fetchData();
            console.log(this.curAdPlatId);
        }
        ,
        handleTitleTabClick(tab, event) {
            // 切换tab 重新请求列表
        }
        ,
        handleCreate() {

            this.resetTemp()
            this.dialogStatus = 'create'
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].clearValidate();
                this.$refs.titleChild.clearSelectList();
            })
        }
        ,
        handleUpdate(row) {
            this.temp = Object.assign({}, row) // copy obj
            this.dialogStatus = 'update'
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.httpGetTitleListByTitlePackageId(row.packageId).then((result) => {
                    this.$refs.titleChild.setSelectList(result);
                });
                this.$refs['dataForm'].clearValidate()
            })
        }
        ,
        handleDelete(row, index) {

            this.$confirm(`确定要删除该数据吗？`, {
                type: "warning",
                //beforeClose 阻止关闭弹窗
                beforeClose: async (action, instance, done) => {
                    //下面这行代码就是弹出的确认删除和取消删除
                    if (action === "confirm") {
                        // 调取接口
                        this.deleteData(row);
                        done();
                    } else {
                        //点击其他地方时就相当于点击了false
                        //done 关闭窗口
                        done();
                    }
                }
            })
        },
        getSelectList(value) {
            this.selectTitleList = value;
        },
        resetTemp() {
            this.selectTitleList = [];
            this.temp = {
                packageName: '',
                adPlatId: this.curAdPlatId,
                customerId: '40',
                titleIdList: []
            }
        },
        createData() {

            if (0 == this.selectTitleList.length) {
                this.$notify({
                    title: '提示',
                    message: '请选择标题',
                    type: 'warn',
                    duration: 2000
                })
                return;
            }

            const titleIdList = [];
            for (let i = 0; i < this.selectTitleList.length; i++) {
                titleIdList.push(this.selectTitleList[i].titleId);
            }
            this.temp.titleIdList = titleIdList;
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.httpAddData(this.temp).then((result) => {
                        this.dialogFormVisible = false
                        this.$notify({
                            title: '成功',
                            message: '新建成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.fetchData();
                    })
                }
            })
        }
        ,
        updateData() {
            if (0 == this.selectTitleList.length) {
                this.$notify({
                    title: '提示',
                    message: '请选择标题',
                    type: 'warn',
                    duration: 2000
                })
                return;
            }

            const titleIdList = [];
            for (let i = 0; i < this.selectTitleList.length; i++) {
                titleIdList.push(this.selectTitleList[i].titleId);
            }
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    const tempData = Object.assign({}, this.temp)
                    tempData.titleIdList = titleIdList;
                    this.httpUpdateData(tempData).then(() => {
                        this.dialogFormVisible = false
                        this.fetchData();
                        this.$notify({
                            title: '成功',
                            message: '更新成功',
                            type: 'success',
                            duration: 2000
                        })
                    })
                }
            })
        }
        ,
        deleteData(row) {
            this.httpDeleteData(row).then(() => {
                this.fetchData();
                this.$notify({
                    title: '成功',
                    message: '删除成功',
                    type: 'success',
                    duration: 2000
                })
            })
        },
        httpGetList() {
            const query = this.listQuery;
            query.adPlatId = this.curAdPlatId;
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/titlePackage/list',
                    data: query,
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
        httpGetTitleListByTitlePackageId(packageId) {
            const query = {};
            query.packageId = packageId
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/titlePackage/title/list',
                    data: query,
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        },
        httpAddData(params) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/titlePackage/add',
                    data: params,
                    method: 'POST'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
        httpUpdateData(params) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/titlePackage/update',
                    data: {...params},
                    method: 'POST'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
        httpDeleteData(params) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/titlePackage/delete',
                    data: {...params},
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/tool/title/titlePackage.vue